import { Box, Typography } from '@mui/material';
import React from 'react';
import { IEmptyPlaceholder } from './interfaces';
import CancelIcon from '@mui/icons-material/Cancel';

export const EmptyPlaceholder: React.FC<IEmptyPlaceholder> = ({
  title,
  subTitle,
  icon: Icon = CancelIcon,
  children,
}): JSX.Element => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      p={4}
      textAlign="center"
      color="text.secondary"
    >
      <Icon sx={{ fontSize: 64, mb: 2 }} />
      <Typography variant="h6" fontWeight="bold">
        {title}
      </Typography>
      {subTitle && <Typography variant="body2">{subTitle}</Typography>}
      {children && <Box>{children}</Box>}
    </Box>
  );
};
